import { CanDeactivateFn } from '@angular/router';
import { MasterWageRatesFormComponent } from '../master-wage-rates-form.component';
import { map, Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { inject } from '@angular/core';
import { MasterWageRateFormService } from '../services/master-wage-rate-form.service';
import { ConfirmationDialogCloseOptionComponent } from '@shared/components/confirmation-dialog-close-option/confirmation-dialog-close-option.component';
import { ClassificationRateCancelTitle } from '../enums/classification-rate-form-mode.enum';

export const userCanGoBackGuard: CanDeactivateFn<
  MasterWageRatesFormComponent
> = (): Observable<boolean> | boolean => {
  const _dialog: MatDialog = inject(MatDialog);
  const _masterWageFormService = inject(MasterWageRateFormService);
  const currentFormMode = _masterWageFormService.currentFormMode;
  const modalTitle = ClassificationRateCancelTitle[currentFormMode()!];
  const masterWageForm = _masterWageFormService.masterWageRatesForm;

  let isUserGoingBack: Observable<boolean> = new Observable();

  if (!masterWageForm.dirty) {
    return true;
  }

  const dialogRef = _dialog.open(ConfirmationDialogCloseOptionComponent, {
    data: {
      title: modalTitle,
      body: `<p>Are you sure you want to close? Your information will not be saved.</p>`,
      cancelButton: 'Cancel',
      cancelButtonId: 'btn-add-master-wage-cancel-close-modal',
      confirmButton: 'Yes',
      confirmButtonId: 'btn-add-master-wage-confirmation-close-modal',
      className: 'modal-title',
    },

    height: 'auto',
    id: 'dialog-close-master-wage-form',
    autoFocus: false,
    width: '570px',
    disableClose: true,
  });
  isUserGoingBack = dialogRef.afterClosed().pipe(
    map((isLeavingThePage: boolean) => {
      if (isLeavingThePage) {
        _masterWageFormService.setIsUserLeavingThePage(true);
        return true;
      }
      _masterWageFormService.setIsUserLeavingThePage(false);
      return false;
    })
  );

  return isUserGoingBack;
};
